<div class="row form-group">
  <div class="col-4 mt-3">
    <button [disabled]="disabled()" #adicionar_ (click)="adicionar()" data-toggle="modal" data-target="#dialogExecutora"
      class="btn btn-sm btn-outline-primary" title="CTRL + I">
      <img src="assets/img/global/plus.png" alt="adicionar" title="Adicionar" height="16" width="16">
      Adicionar
    </button>
  </div>
</div>
<table class="table table-eddy" *ngIf="lista && lista.length > 0">
  <thead>
    <tr>
      <th scope="col">Observações</th>
      <th scope="col" class="text-center">Responsável</th>
      <th scope="col" class="text-center">Data/Hora do Registro</th>
      <th scope="col" style="width: 120px;"></th>
    </tr>
  </thead>
  <tbody>
    <tr *ngFor="let item of lista; let idx = index">
      <td *ngIf="!item.editavel" style="width: 60%">{{item.observacao}}</td>
      <td *ngIf="!item.editavel" class="text-center" style="width: 20%">{{item.responsavel?.nome}}</td>
      <td *ngIf="!item.editavel" class="text-center" style="width: 20%">{{item.data_cadastro | date:'dd/MM/yyyy
        HH:mm'}}</td>
      <td *ngIf="item.editavel" style="width: 60%">
        <input #obs_ [(ngModel)]="item.observacao" #obsText="ngModel" [ngModelOptions]="{standalone: true}"
          type="text" class="form-control form-control-sm" id="obs">
      </td>
      <td *ngIf="item.editavel" style="width: 20%"></td>
      <td *ngIf="item.editavel" style="width: 20%"></td>
      <td class="text-right" style="min-width: 120px;">
        <button [disabled]="disabled()" *ngIf="!item.editavel && (!item.responsavel || item.responsavel.id === this.login.usuario.id)"
          (click)="editar(item)" data-toggle="modal" data-target="#dialogExecutora"
          class="btn btn-sm btn-outline-primary mr-2">
          <img src="assets/img/global/pencil.png" alt="editar" height="16" width="16">
        </button>
        <button [disabled]="disabled()" *ngIf="!item.editavel && (!item.responsavel || item.responsavel.id === this.login.usuario.id)"
          (click)="remover(item, idx)" class="btn btn-sm btn-outline-primary mr-2">
          <img src="assets/img/global/bin_closed.png" alt="remover" height="16" width="16">
        </button>
        <button *ngIf="item.editavel" (click)="salvar(item)" class="btn btn-sm btn-outline-secondary mr-2">
          <img src="assets/img/global/tick.png" alt="salvar" height="16" width="16">
        </button>
        <button *ngIf="item.editavel" (click)="cancelar(item, idx)" class="btn btn-sm btn-outline-primary mr-2">
          <img src="assets/img/global/cross.png" alt="editar" height="16" width="16">
        </button>
      </td>
    </tr>
  </tbody>
</table>